export default __webpack_public_path__ + "static/media/icon-ScheduleConsultation.6064d55c.svg";